import * as angular from "angular";
import * as _ from "lodash";
import {ServiceTimeRequestsService} from "./service-time-requests.service";

export class ServiceTimeDialogService {
  constructor(private $mdDialog) {
  }

  // help(event) {
  //   this.$mdDialog.show({
  //     controller: ($scope) => {
  //       $scope.ok = this.$mdDialog.hide;
  //       $scope.cancel = this.$mdDialog.cancel;
  //     },
  //     templateUrl: 'app/modules/price-plan/views/dialogs/service-time-help-dialog.tmpl.html',
  //     parent: angular.element(document.body),
  //     targetEvent: event,
  //     clickOutsideToClose: true
  //   });
  // }

  addSpecialDayEvent(programId, days, currentDay, query, jsEvent) {
    return this.$mdDialog.show({
      template: '<price-plan-create-event-dialog-view program-id="vm.programId" days="vm.days" ' +
        'current-day="vm.currentDay" query="vm.query"></price-plan-create-event-dialog-view>',
      controllerAs: 'vm',
      controller: function () {
        this.days = days;
        this.currentDay = currentDay;
        this.query = query;
        this.programId = programId;
      },
      targetEvent: jsEvent
    });
  }

  addServiceTimeEvent(programId, days, currentDay, query, jsEvent) {
    return this.$mdDialog.show({
      template: '<price-plan-create-service-time-event-dialog-view program-id="vm.programId" days="vm.days" ' +
        'current-day="vm.currentDay" query="vm.query"></price-plan-create-service-time-event-dialog-view>',
      controllerAs: 'vm',
      controller: function () {
        this.days = days;
        this.currentDay = currentDay;
        this.query = query;
        this.programId = programId;
      },
      targetEvent: jsEvent
    });
  }

  editEvent(programId, day, event, jsEvent, query) {
    return this.$mdDialog.show({
      template: '<price-plan-calendar-event-dialog-view program-id="vm.programId" day="vm.day" ' +
        'event-ref="vm.event" query="vm.query"></price-plan-calendar-event-dialog-view>',
      controllerAs: 'vm',
      controller: function () {
        this.day = day;
        this.query = query;
        this.event = event;
        this.programId = programId;
      },
      targetEvent: jsEvent
    });
  }

  duplicateServiceTimeDay(serviceTimeEvent, serviceTimeDays, programId, query) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/duplicate-hours-of-operation.html').default,
      controller: function ($scope, $mdSelect, commonsConstants, serviceTimeRequestsService: ServiceTimeRequestsService) {

        // $scope.timeSlot = angular.copy(originalTimeSlot);
        $scope.serviceTimeDays = angular.copy(serviceTimeDays);
        $scope.daysMap = commonsConstants.daysMap;
        $scope.selectedDays = [];

        const serviceTimeDay = _.findKey(commonsConstants.daysMap, (value) => {
          return value === serviceTimeEvent.$$day.dayOfWeek
        });

        if (serviceTimeDay) {
          $scope.selectedDays.push(serviceTimeDay)
        }

        $scope.selectedDaySlot = serviceTimeEvent.$$day.slot;

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onCloseSelect = () => {
          $mdSelect.hide();
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              const daysToAddServiceTime = _.filter($scope.serviceTimeDays, (st) => {
                return !_.isUndefined(_.find($scope.selectedDays, sd => {
                  const selectedServiceTimeDay = st.dayOfWeek.substring(0, 2)
                  return selectedServiceTimeDay === sd && selectedServiceTimeDay !== serviceTimeDay;
                }))
              })

              _.forEach(daysToAddServiceTime, (dayToAddSlot) => {
                dayToAddSlot.dayChunks.push($scope.selectedDaySlot);
              })

              serviceTimeRequestsService.updateCreateServiceTime(programId, daysToAddServiceTime, query).then(
                (serviceTime) => {
                  self.$mdDialog.hide({
                    serviceTime: serviceTime,
                    updatedDays: daysToAddServiceTime
                  });

                }
              ).catch((error) => self.$mdDialog.cancel(error));
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })

  }

}

angular
  .module('bringoz.admin.pricePlan')
  .service('serviceTimeDialogService', ServiceTimeDialogService);
